import { connect } from 'react-redux';
import DefaultPage from './component';
import './styles.scss';

export const mapStateToProps = state => (
  {
    authenticated: state.user.authenticated,
    done: state.survey.done,
    loading: state.user.loadingUserData,
  }
);

export default connect(mapStateToProps, {})(DefaultPage);
